module.exports = __webpack_public_path__ + "static/media/04.037ab427.png";